import { Pipe, PipeTransform } from '@angular/core';
import { getId } from '@fleet-beat/core';

@Pipe({ name: 'disabledAutocompleteItem' })
export class DisabledAutocompleteItemPipe implements PipeTransform {
  transform(item: string | { id?: string; value?: string }, disabledMap: Record<string, boolean>): boolean {
    if (!item || !disabledMap) {
      return false;
    }
    const key: string = getId(item) || (typeof item !== 'string' && item.value);
    return Boolean(disabledMap[key]);
  }
}
